import { useUserModuleState } from "..";

export default function useUserAnswers(trackID: TrackId) {
    const {tracks} = useUserModuleState()

    return tracks.find(t => t.id === trackID)?.answers || []
}
